import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  InputPassword,
  InputSelect,
  InputText,
  setTitleCase,
} from "app/components/template/partials";
import { RegexUsername } from "configs/regex";
import { RoleDropDown } from "configs/roles";
import { Field, Formik } from "formik";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createUser } from "utils/action";
import * as Yup from "yup";

// REDUXp
// inital values form
const initialValues = {
  username: "",
  password: "",
  confirm_password: "",
  role: null,
  email_nohp: "",
  nama_lengkap: "",
  keterangan: "",
};

// form field validation schema
const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required("Nama User wajib diisi!")
    .matches(
      RegexUsername,
      "Format Nama Pengguna tidak sesuai, minimal 6 digit dan hanya menggunakan huruf dan angka"
    ),
  password: Yup.string().required("Kata Sandi wajib diisi!"),
  confirm_password: Yup.string()
    .required("Konfirmasi Sandi wajib diisi!")
    .oneOf(
      [Yup.ref("password"), null],
      "Konfirmasi Kata Sandi tidak sama dengan Kata Sandi"
    ),
  role: Yup.object().nullable().required("Role wajib diisi!"),
  nama_lengkap: Yup.string().required("Nama Lengkap wajib diisi!"),
});

export function CreateUser() {
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const showDialog = location.state?.showDialog ?? false;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const onHide = () => {
    navigate("/user-management");
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const request = {
      username: values.username,
      password: values.password,
      role: values.role?.value,
      email_nohp: values.email_nophp,
      nama_lengkap: values.nama_lengkap,
      keterangan: values.keterangan,
    };

    // send to backend
    try {
      await createUser(request);
      toast.success(setTitleCase("berhasil membuat user"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-create-user-title"
    >
      <DialogTitle id="responsive-dialog-create-user-title">
        Buat Pengguna
      </DialogTitle>
      <Divider />
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="username"
                    label="Nama User"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputPassword}
                    name="password"
                    label="Kata Sandi"
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <Field
                    component={InputPassword}
                    name="confirm_password"
                    label="Konfirmasi Kata Sandi"
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputSelect}
                    options={RoleDropDown}
                    getOptionLabel={(option) => option?.label ?? ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    name="role"
                    label="Role User"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputText}
                    name="email_nohp"
                    label="Nomor HP"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputText}
                    name="nama_lengkap"
                    label="Nama Lengkap"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <Field
                    component={InputText}
                    name="keterangan"
                    label="Keterangan Pengguna"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Batal
              </Button>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Simpan
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
